/**
 * Ryan O'Dowd
 * 2022-05-22
 * © Copyright 2021 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      maxWidth: 600, // @TODO: globalScale this?
    },
    topWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginBottom: globalScale * 8,
    },
    header: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: globalScale * 4,
    },
    title: {
      fontSize: globalScale * 18,
      fontFamily: fonts.primaryBold,
      color: colors.primaryExtraDark,
    },
  };
};

export default getStyles;
